var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.1462 11.6464L11.8533 7.35348C11.6581 7.15822 11.3415 7.15822 11.1462 7.35348L10.4428 8.05686C10.2478 8.25193 10.2475 8.56814 10.4423 8.76348L13.6698 11.9999L10.4423 15.2364C10.2475 15.4317 10.2478 15.7479 10.4428 15.943L11.1462 16.6464C11.3415 16.8416 11.6581 16.8416 11.8533 16.6464L16.1462 12.3535C16.3415 12.1582 16.3415 11.8416 16.1462 11.6464Z",
  fill: "#CCE3F0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 22.5C18.299 22.5 23 17.799 23 12C23 6.20101 18.299 1.5 12.5 1.5C6.70101 1.5 2 6.20101 2 12C2 17.799 6.70101 22.5 12.5 22.5ZM12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
  fill: "#CCE3F0"
})));
export default SvgArrowRightCircle;